/* eslint-disable */
import axios from "axios";
import store from "../../store";
import VPagination from "@hennge/vue3-pagination";
import MilestoneModal from "./MilestoneModal.vue";

export default {
    name: "SubjectMilestone",
    components: { VPagination, MilestoneModal },

    data() {
        return {
            baseapi: process.env.VUE_APP_Service_URL,
            milestoneList: [],
            loading: false,

            currentPage: 1,
            totalPage: 1,
            pageSize: 10,
            totalCount: 0,
            SortProperty: "createdAt",
            SortOrder: 1,
            SortOrderInt: 0,
            isAscending: true,

            studyId: "",
            token: "",

            showModal: false,
            editingId: null
        };
    },

      computed:{
           rollsprivilages() {
           return store.getters.getRolesprivilegeData || [];
            }
              },

    mounted() {
        this.studyId = store.getters.getStudyIs;
        this.token = store.getters.getIdToken;

        this.getMilestones();
    },

    methods: {
        async getMilestones() {
            try {
                this.loading = true;

                const res = await axios.get(
                    `${this.baseapi}/management/patient/listsubjectmilestone`,
                    {
                        params: {
                            studyId: this.studyId,
                             pagesize: this.pageSize,
                            pageindex: this.currentPage,
                            SortProperty: this.SortProperty,
                            SortOrder: this.isAscending ? 0 : 1
                        },
                        headers: {
                            Authorization: "Bearer " + this.token
                        }
                    }
                );

                this.milestoneList = res.data.data || [];
                this.totalCount = res.data.totalCount;
                this.totalPage = Math.ceil(this.totalCount / this.pageSize);

            } catch (err) {
                console.error(err);
                this.milestoneList = [];
            } finally {
                this.loading = false;
            }
        },

        loadPage(page) {
            this.currentPage = page;
            this.getMilestones();
        },

        createMilestone() {
            this.editingId = null;
            this.showModal = true;
        },

        editMilestone(id) {
            this.editingId = id;
            this.showModal = true;
        },

        closeModal() {
            this.showModal = false;
            this.editingId = null;
        },

        async deleteMilestone(id) {
            if (!confirm("Delete this milestone?")) return;

            try {
                await axios.delete(
                    `${this.baseapi}/management/patient/deletesubjectmilestone?id=${id}`,
                    {
                        headers: {
                            Authorization: "Bearer " + this.token
                        }
                    }
                );

                if (this.milestoneList.length === 1 && this.currentPage > 1) {
                    this.currentPage--;
                }

                this.getMilestones();

            } catch (err) {
                console.error(err);
                alert("Delete failed");
            }
        },
         SortSelected(prop) {
            if (this.SortProperty === prop) {
                this.isAscending = !this.isAscending;
            } else {
                this.SortProperty = prop;
                this.isAscending = true;
            }

            this.getMilestones();
        },
    }
};